import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ParticipantDTO } from '@/models/ParticipantDTO';
import LocalityAutoComplete from '../LocalityAutoComplete/LocalityAutoComplete';
import InputText from '../inputs/InputText/InputText';
import InputDate from '../inputs/InputDate/InputDate';
import { GetterTypes } from '@/store-vuex/types';
import ParticipantService from '@/services/participant.service';

@Component({
  components: {
    LocalityAutoComplete,
    InputText,
    InputDate,
  },
})
export default class ParticipantAdministrative extends Vue {
  private participant: ParticipantDTO = {} as ParticipantDTO;

  protected async mounted() {
    await ParticipantService.fetchParticipant(this.$store.getters[GetterTypes.participantId])
      .then((res: ParticipantDTO) => {
        this.participant = res;
      });
  }
}
